/* Coniglio d'Oro — pdp.js (product detail page) */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- Gallery: thumbnails switch main image ---------- */
  function initGallery() {
    const gallery = $('[data-pdp-gallery]');
    if (!gallery) return;
    const mains = $$('[data-pdp-main-img]', gallery);
    const thumbs = $$('[data-pdp-thumb]', gallery);

    function activate(idx) {
      mains.forEach((m, i) => m.classList.toggle('is-active', i === idx));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
    }
    thumbs.forEach((t, i) => {
      t.addEventListener('click', e => { e.preventDefault(); activate(i); });
    });
    if (mains[0]) activate(0);
  }

  /* ---------- Variant swap (color/metal swatch updates image + price + URL) ---------- */
  function initVariantSwap() {
    const form = $('[data-pdp-form]');
    if (!form) return;
    const dataEl = $('[data-pdp-variants]');
    if (!dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch { return; }

    const optionInputs = $$('[data-pdp-option]', form);

    function currentSelection() {
      return optionInputs.reduce((acc, el) => {
        const checked = form.querySelector(`[data-pdp-option][name="${el.name}"]:checked`) || el;
        if (el.type === 'radio') {
          const c = form.querySelector(`[name="${el.name}"]:checked`);
          if (c) acc[el.dataset.optionIndex] = c.value;
        } else {
          acc[el.dataset.optionIndex] = el.value;
        }
        return acc;
      }, {});
    }

    function findVariant() {
      const sel = currentSelection();
      return variants.find(v => {
        return v.options.every((opt, i) => opt === sel[i]);
      });
    }

    /* Reflect the picked option values back into the UI:
       the "Maat: 14" label next to each group and the active swatch.
       Runs before the availability check so the page always shows what is picked. */
    function syncOptionUi() {
      const sel = currentSelection();
      optionInputs.forEach(el => {
        const idx = Number(el.dataset.optionIndex);
        const label = form.querySelector('[data-option-selected-' + (idx + 1) + ']');
        if (label && sel[idx] != null) label.textContent = sel[idx];
      });
      $$('.swatch', form).forEach(sw => {
        const radio = sw.querySelector('input[type="radio"]');
        if (radio) sw.classList.toggle('is-active', radio.checked);
      });
    }

    function applyVariant() {
      syncOptionUi();
      const v = findVariant();
      const idInput = $('[data-pdp-variant-id]', form);
      const submitBtn = $('[data-pdp-submit]', form);
      const priceEl = $('[data-pdp-price]');
      const stickyPriceEl = $('.sticky-atc__price');
      if (!v) {
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Niet beschikbaar'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (submitBtn) {
        submitBtn.disabled = !v.available;
        submitBtn.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht';
      }
      if (window.moneyFormat) {
        const formatted = window.moneyFormat(v.price);
        if (priceEl) priceEl.textContent = formatted;
        if (stickyPriceEl) stickyPriceEl.textContent = formatted;
      }
      if (v.featured_image && v.featured_image.src) {
        const main = $('[data-pdp-main-img]');
        if (main) main.src = v.featured_image.src;
      }
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }

    form.addEventListener('change', applyVariant);
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    $$('[data-pdp-acc]').forEach(acc => {
      // Native <details> handles it; just attach analytics hook if needed.
    });
  }

  /* ---------- Sticky add-to-cart on mobile ---------- */
  function initStickyAtc() {
    const sticky = $('[data-sticky-atc]');
    const mainBtn = $('[data-pdp-submit]');
    if (!sticky || !mainBtn) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -80px 0px' });
    io.observe(mainBtn);
    const stickyBtn = $('[data-sticky-atc-btn]', sticky);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        const form = $('[data-pdp-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  /* ---------- Size chart modal ---------- */
  function initSizeChart() {
    const opens = $$('[data-size-chart-open]');
    const modal = $('[data-size-chart-modal]');
    if (!modal) return;
    const close = $('[data-size-chart-close]', modal);
    opens.forEach(o => o.addEventListener('click', e => {
      e.preventDefault();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    }));
    function hide() { modal.hidden = true; document.body.style.overflow = ''; }
    if (close) close.addEventListener('click', hide);
    modal.addEventListener('click', e => { if (e.target === modal) hide(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) hide(); });
  }

  /* ---------- ATC ajax submit ---------- */
  function showAtcToast() {
    let t = document.querySelector('[data-pdp-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'pdp-toast';
      t.setAttribute('data-pdp-toast', '');
      var cartUrl = (window.shop && window.shop.routes && window.shop.routes.cart_url) || '/cart';
      t.innerHTML = '<span class="pdp-toast__icon">✓</span><div><p class="pdp-toast__title">Toegevoegd aan winkelwagen</p><a class="pdp-toast__link" href="' + cartUrl + '">Bekijk winkelwagen →</a></div>';
      document.body.appendChild(t);
    }
    t.classList.remove('is-out');
    requestAnimationFrame(() => t.classList.add('is-in'));
    clearTimeout(t._hide);
    t._hide = setTimeout(() => { t.classList.remove('is-in'); t.classList.add('is-out'); }, 3500);
  }

  function initAtcSubmit() {
    const form = $('[data-pdp-form]');
    if (!form) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('[data-pdp-submit]', form);
      const orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Bezig...'; }
      try {
        const fd = new FormData(form);
        const res = await fetch(window.shop.routes.cart_add_url + '.js', {
          method: 'POST', body: fd, headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error('fail');
        if (btn) btn.textContent = 'Toegevoegd ✓';
        if (window.updateCartCount) await window.updateCartCount();
        showAtcToast();
        setTimeout(() => { if (btn) { btn.textContent = orig; btn.disabled = false; } }, 1800);
      } catch {
        if (btn) { btn.textContent = 'Probeer opnieuw'; btn.disabled = false; }
      }
    });
  }

  /* ---------- Zoom modal ---------- */
  function initZoom() {
    const modal = document.querySelector('[data-pdp-zoom-modal]');
    if (!modal) return;
    const imgEl = modal.querySelector('[data-pdp-zoom-img]');
    const counter = modal.querySelector('[data-pdp-zoom-counter]');
    const closeBtn = modal.querySelector('[data-pdp-zoom-close]');
    const prevBtn = modal.querySelector('[data-pdp-zoom-prev]');
    const nextBtn = modal.querySelector('[data-pdp-zoom-next]');
    const trigger = document.querySelector('[data-pdp-zoom-open]');
    const sources = Array.from(document.querySelectorAll('[data-pdp-main-img]'));
    if (!sources.length) return;
    let idx = 0;

    function show(i) {
      idx = (i + sources.length) % sources.length;
      const src = sources[idx].getAttribute('data-zoom-src') || sources[idx].src;
      imgEl.src = src;
      imgEl.alt = sources[idx].alt || '';
      if (counter) counter.textContent = (idx + 1) + ' / ' + sources.length;
    }
    function open(i) {
      show(i || 0);
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (trigger) trigger.addEventListener('click', () => {
      const active = sources.find((s) => s.classList.contains('is-active'));
      open(active ? sources.indexOf(active) : 0);
    });
    sources.forEach((img) => {
      img.addEventListener('click', () => {
        if (!window.matchMedia('(pointer:fine)').matches) return;
        const active = sources.find((s) => s.classList.contains('is-active'));
        open(active ? sources.indexOf(active) : 0);
      });
      img.style.cursor = 'zoom-in';
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', () => show(idx - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(idx + 1));
    modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
    document.addEventListener('keydown', (e) => {
      if (modal.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });

    let tx = null;
    modal.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; }, { passive: true });
    modal.addEventListener('touchend', (e) => {
      if (tx == null) return;
      const dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
      tx = null;
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initVariantSwap();
    initAccordions();
    initStickyAtc();
    initSizeChart();
    initAtcSubmit();
    initZoom();
  });
})();
